window.SurchargeCart = {
  isSurchargeLine(item) {
    const properties = item.properties || {};
    return (
      properties._paint_upcharge === 'true' ||
      properties._surcharge === 'true' ||
      Boolean(properties['Surcharge Code'])
    );
  },

  paintCodeOf(item) {
    const properties = item.properties || {};
    return String(
      properties['Paint code'] ||
        properties._paint_code ||
        properties._surcharge_code ||
        properties['Surcharge Code'] ||
        ''
    ).trim();
  },

  codeOf(item) {
    return this.paintCodeOf(item).toUpperCase();
  },

  isLinkedProduct(item) {
    if (this.isSurchargeLine(item)) return false;
    return Boolean(this.paintCodeOf(item));
  },

  hasLinkedProducts(cart) {
    return cart.items.some((item) => this.isLinkedProduct(item));
  },

  productQuantityForCode(cart, _code, overrideKey, overrideQty) {
    return cart.items.reduce((sum, item) => {
      if (!this.isLinkedProduct(item)) return sum;
      const qty = item.key === overrideKey ? overrideQty : item.quantity;
      return sum + qty;
    }, 0);
  },

  surchargeLine(cart) {
    return cart.items.find((item) => this.isSurchargeLine(item));
  },

  isPaintPropertyKey(key) {
    return (
      key === 'Paint code' ||
      key === '_paint_code' ||
      key === '_surcharge_code' ||
      key === 'Surcharge Code'
    );
  },

  linkedProductTitles(cart, overrideKey, overrideQty) {
    const titles = [];
    const seen = new Set();
    cart.items.forEach((item) => {
      if (!this.isLinkedProduct(item)) return;
      const qty = item.key === overrideKey ? Number(overrideQty) : item.quantity;
      if (qty <= 0) return;
      const title = String(item.product_title || item.title || '').trim();
      if (!title) return;
      const token = title.toLowerCase();
      if (seen.has(token)) return;
      seen.add(token);
      titles.push(title);
    });
    return titles;
  },

  surchargeProperties(cart, options = {}) {
    const titles = this.linkedProductTitles(cart, options.overrideKey, options.overrideQty);
    const extraTitle = String(options.extraTitle || '').trim();
    if (extraTitle && !titles.some((title) => title.toLowerCase() === extraTitle.toLowerCase())) {
      titles.push(extraTitle);
    }

    const properties = { _paint_upcharge: 'true' };
    const paintCode = String(options.paintCode || '').trim();
    if (paintCode) properties._paint_code = paintCode;

    titles.forEach((title, index) => {
      const key = titles.length === 1 ? 'Product' : `Product ${index + 1}`;
      properties[key] = title;
    });
    return properties;
  },

  propertiesWithoutPaintCode(item) {
    const next = {};
    Object.entries(item.properties || {}).forEach(([key, value]) => {
      if (this.isPaintPropertyKey(key)) return;
      if (value == null || value === '') return;
      next[key] = value;
    });
    return next;
  },

  linkedItemAddPayload(item) {
    const payload = {
      id: item.variant_id,
      quantity: item.quantity,
    };
    const properties = this.propertiesWithoutPaintCode(item);
    if (Object.keys(properties).length) payload.properties = properties;
    const sellingPlan =
      item.selling_plan_allocation &&
      item.selling_plan_allocation.selling_plan &&
      item.selling_plan_allocation.selling_plan.id;
    if (sellingPlan) payload.selling_plan = sellingPlan;
    return payload;
  },

  buildChanges(cart, lineIndex, quantity) {
    const item = cart.items[lineIndex];
    if (!item) return [];

    const qty = Number(quantity);
    const changes = [];

    if (this.isSurchargeLine(item)) {
      if (qty === 0) {
        cart.items.forEach((line) => {
          if (!this.isLinkedProduct(line)) return;
          const remaining = this.propertiesWithoutPaintCode(line);
          if (Object.keys(remaining).length) {
            changes.push({ id: line.key, quantity: line.quantity, properties: remaining });
            return;
          }
          changes.push({ add: { items: [this.linkedItemAddPayload(line)] } });
          changes.push({ id: line.key, quantity: 0 });
        });
        changes.push({ id: item.key, quantity: 0 });
        return changes;
      }
      const linkedQty = this.productQuantityForCode(cart);
      changes.push({
        id: item.key,
        quantity: linkedQty > 0 ? linkedQty : item.quantity,
        properties: this.surchargeProperties(cart, { paintCode: this.paintCodeOf(item) }),
      });
      return changes;
    }

    changes.push({ id: item.key, quantity: qty });
    const surcharge = this.surchargeLine(cart);
    if (!surcharge) return changes;
    if (!this.isLinkedProduct(item) && qty !== 0) return changes;
    changes.push({
      id: surcharge.key,
      quantity: this.productQuantityForCode(cart, null, item.key, qty),
      properties: this.surchargeProperties(cart, {
        overrideKey: item.key,
        overrideQty: qty,
        paintCode: this.paintCodeOf(surcharge),
      }),
    });
    return changes;
  },
};
